import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';

const orgCollection = StoreModuleMap[ItemTypeConsts.organizations];
const onboardingModule = 'OnboardingModule';

export default {
  computed: {
    ...mapGetters(orgCollection, {
      orgIsOlderThanDays: 'getOrgIsOlderThanDays',
    }),

    ...mapState(onboardingModule, [
      'showProductTour',
    ]),

    shouldShowForAdmin() {
      // show for all admins if this.showForNewAdmins or org created more than 1 day ago
      // and the product tour is not open
      return !this.showProductTour && (this.showForNewAdmins || this.orgIsOlderThanDays(1));
    },
  },

  props: {
    showForNewAdmins: {
      type: Boolean,
      // default to hiding banners/announcements from admins that are 1 day old
      default: false,
    },
  },
};
